
<script>
import { Bar } from 'vue-chartjs'

export default {
    name: 'OtherDetailsDemographics',
    extends: Bar,

    props: {
        clientDemographics: {
            type: Object,
            default: () => ({}),
        },
        insuranceBasedListings: {
            type: Array,
            default: []
        },
        practiceType : {
            type: Number,
            default: 0
        }
    },

    data: () => ({
        maxYvalue: 0
    }),

    computed: {
        demographicFields () {
            let define_demographicFields
            if ( this.insuranceBasedListings.includes(this.practiceType) ) {
                define_demographicFields = [
                    'under-50',
                    '51-100',
                    '101-150',
                    '151-200',
                    '201-250',
                    '251+',
                ]
            } else {
                define_demographicFields = [
                    'under-40',
                    '41-50',
                    '51-60',
                    '61-70',
                    '71-80',
                    '81+',
                    'Institutions'
                ]
            }
            return define_demographicFields
        },

        graphData () {
            let define_graphData
            if ( this.insuranceBasedListings.includes(this.practiceType) ) {
                define_graphData = {
                    labels: [
                        ['Under 50'],
                        ['51-100'],
                        ['101-150'],
                        ['151-200'],
                        ['201-250'],
                        ['251+'],
                    ],
                    datasets: [
                        {
                            label: '# of Participants',
                            data: [1, 2, 3, 4, 5, 6],
                            backgroundColor: '#0096A6',
                            barPercentage: 0.8,
                            minBarLength: 10,
                            categoryPercentage: 0.8,
                        },
                        {
                            label: '% of Revenue',
                            data: [1, 2, 3, 4, 5, 6],
                            backgroundColor: '#97C131',
                            barPercentage: 0.8,
                            minBarLength: 10,
                            categoryPercentage: 0.8,
                        }
                    ],
                }
            } else {
                define_graphData = {
                    labels: [
                        // ['Under', 'Age 40'],
                        // ['Age', '41-50'],
                        // ['Age', '51-60'],
                        // ['Age', '61-70'],
                        // ['Age', '71-80'],
                        // ['Age', '81+'],
                        // ['Institutions', ''],
                        ['Under age 40'],
                        ['Age 41-50'],
                        ['Age 51-60'],
                        ['Age 61-70'],
                        ['Age 71-80'],
                        ['Age 81+'],
                        ['Institutions', '']
                    ],
                    datasets: [
                        {
                            label: '% of Clients',
                            data: [1, 2, 3, 4, 5, 6],
                            backgroundColor: '#0096A6',
                            barPercentage: 0.8,
                            categoryPercentage: 0.8,
                            minBarLength: 10,
                        },
                        {
                            label: '% of AUM',
                            data: [1, 2, 3, 4, 5, 6],
                            backgroundColor: '#97C131',
                            barPercentage: 0.8,
                            categoryPercentage: 0.8,
                            minBarLength: 10,
                        },
                    ],
                }
            }
            return define_graphData
        },

        graphOptions () {
            let define_graphData = { 
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 40,
                        left: 10,
                    },
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        boxWidth: 15,
                        padding: 20,
                    },
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false,
                            drawTicks: false,
                        },
                        ticks: {
                            padding: 15,
                            maxRotation: 40,
                            autoSkip: false
                        },
                    }],
                    yAxes: [{
                        gridLines: {
                            drawBorder: false,
                            drawTicks: false,
                        },
                        ticks: {
                            padding: 10,
                            maxRotation: 0,
                            min: 0,
                            max: this.maxYvalue,
                            maxTicksLimit: 10,
                            callback: value => `${value}%`,
                        },
                    }],
                },
                tooltips: {
                    callbacks: {
                        title: ([{ label }]) => {
                            return (label || '').replace(/[,]/g, ' ')
                        },
                        label: ({ datasetIndex, value }, data) => {
                            return `${data.datasets[datasetIndex].label}: ${value}%`
                        },
                    },
                }
            }
            return define_graphData
        }
    },

    mounted () {
        this.buildGraphData()
        this.renderChart(this.graphData, this.graphOptions)
    },

    methods: {
        buildGraphData () {
            if (!this.clientDemographics) return
            
            this.graphData.datasets[0].data = []
            this.graphData.datasets[1].data = []

            this.demographicFields.forEach(field => {
                if ( this.insuranceBasedListings.includes(this.practiceType) ) {
                    const { revenue, participants } = (this.clientDemographics[field] || {})

                    this.graphData.datasets[0].data.push(participants || 0)
                    this.graphData.datasets[1].data.push(revenue || 0)

                    this.maxYvalue = parseInt(revenue) > parseInt(this.maxYvalue) ? parseInt(revenue) : parseInt(this.maxYvalue)
                    this.maxYvalue = parseInt(participants) > parseInt(this.maxYvalue) ? parseInt(participants) : parseInt(this.maxYvalue)

                } else {
                    const { age, assets } = (this.clientDemographics[field] || {})

                    this.graphData.datasets[0].data.push(age || 0)
                    this.graphData.datasets[1].data.push(assets || 0)

                    this.maxYvalue = parseInt(assets) > parseInt(this.maxYvalue) ? parseInt(assets) : parseInt(this.maxYvalue)
                    this.maxYvalue = parseInt(age) > parseInt(this.maxYvalue) ? parseInt(age) : parseInt(this.maxYvalue)
                }
            })

            this.maxYvalue = Math.ceil(this.maxYvalue / 10) * 10;
        },
    },
}
</script>

<style scoped>
    div {
        max-height: 400px;
        max-width: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-other/Demographics.vue